$(document).on('ready', function () {

    $.fn.scrollingToElement = function () {
         var $self = $(this);
         var url;
         var $body = $('.js-fc-body');

         var init = function () {
             $self.on('click', function () {
                 url = "." + $(this).attr('data-scroll');
                 var $element = $body.find(url);
                 if ($element.length <= 0) {
                     url = $(this).attr('data-url');
                     if(url) {
                         window.location.href = url;
                     }
                     return;
                 }
                 $('body,html').animate({
                     scrollTop: $element.offset().top - 100
                 }, 1000);
             });
         };

         init();

    };

    $('.js-link-scroll').each(function () {
        $(this).data('scrollingToElement', $(this).scrollingToElement());
    });
});
